
  export default {
    hydrate(data: any, container: HTMLElement) {
      const React = require('react');
      const ReactDOMClient = require('react-dom/client');
      const { default: Component } = require('/app/src/components/locale-selector/LocaleSelector');
      ReactDOMClient.hydrateRoot(container, <Component {...data} />);
    },
  };
